import { InspectionEmailComponent } from '../../app-lite/inspections/inspection.email.component';
import { InspectionSmsComponent } from '../../app-lite/inspections/inspection.sms.component';

import ApproveInspectionHtml from './inspection.approve.html';

export function InspectionService (
  $uibModal,
  $q,
  $translate,
  $window,
  API,
  confirm,
  dateParsing,
  messengerApi,
  SUBSCRIPTIONKEYS,
  workshopAPI
) {
  var Inspection = function (inspection, groups, settings, company) {
    this.comment1                     = inspection.comment1;
    this.comment1_label               = inspection.comment1_label;
    this.comment2                     = inspection.comment2;
    this.comment2_label               = inspection.comment2_label;
    this.company_settings             = company;
    this.contact_email                = inspection.contact_email || settings.default_contact_email;
    this.contact_name                 = inspection.contact_name || settings.default_contact_name;
    this.contact_number               = inspection.contact_number || settings.default_contact_number;
    this.customer_comments            = inspection.customer_comments;
    this.customer_email               = inspection.customer_email;
    this.customer_id                  = inspection.customer_id;
    this.customer_viewed              = inspection.customer_viewed;
    this.description                  = inspection.description;
    this.email_sent                   = inspection.email_sent;
    this.event_id                     = inspection.event_id;
    this.groups                       = [];
    this.hide_estimated_cost          = settings.hide_estimated_cost;
    this.hide_estimated_hours         = settings.hide_estimated_hours;
    this.id                           = inspection.id;
    this.inspection_date              = inspection.inspection_date || dateParsing.today();
    this.inspection_number            = inspection.inspection_number;
    this.inspection_status            = inspection.inspection_status || 'D';
    this.invoice_id                   = inspection.invoice_id;
    this.service_adviser_display_name = inspection.service_adviser_display_name || settings.default_service_adviser_id
    this.service_adviser_id           = inspection.service_adviser_id || settings.default_service_adviser_id;
    this.status                       = settings.statuses;
    this.status_description           = this.getStatus(this.inspection_status).description;
    this.template_description         = inspection.template_description;
    this.template_id                  = inspection.template_id;
    this.template_name                = inspection.template_name;
    this.vehicle_id                   = inspection.vehicle_id;

    this.initializeGroups(inspection.inspection_items_attributes, groups);
  };

  Inspection.prototype.getStatus = function (statusCode) {
    var self = this;
    var status = {};

    for (var i = 0; i < self.status.length; i++) {
      if (self.status[i].code === statusCode) {
        status = self.status[i];
        break;
      }
    }

    return status;
  };

  Inspection.prototype.checkStatus = function (status) {
    var self = this;
    var code;

    switch (status) {
      case 'draft':
        code = 'D';
        break;
      case 'requested':
        code = 'RA';
        break;
      case 'finalized':
        code = 'F';
        break;
      case 'approved':
        code = 'A';
        break;
      case 'refused':
        code = 'R';
        break;
      default:
        code = 'D';
        break;
    }

    return self.inspection_status === code;
  };

  Inspection.prototype.isReadonly = function () {
    var self = this;

    return !self.checkStatus('draft');
  };

  Inspection.prototype.getTemplate = function () {
    var self = this;

    if (!self.template_id) {
      return $q.when([]);
    }

    return workshopAPI.get('/inspection_template', self.template_id).then(function (template) {
      self.template_name = template.name;
      self.template_description = template.description;
      self.comment1_label = template.comment1_label || $translate.instant('JS_SPACE.INSPECTIONS.COMMENT', { num: '1' });
      self.comment2_label = template.comment2_label || $translate.instant('JS_SPACE.INSPECTIONS.COMMENT', { num: '2' });

      angular.forEach(template.inspection_template_items_attributes, function (item) {
        item.template_item_id = item.id;
        item.id = undefined;
      });

      return template;
    });
  };

  Inspection.prototype.initializeGroups = function (items, groups) {
    var self = this;
    var groupCodes = [];

    $q.when().then(function () {
      return items ? $q.when(): self.getTemplate();
    }).then(function (template) {
      items = items || template.inspection_template_items_attributes;

      angular.forEach(items, function (item) {
        item.hide_estimated_cost = self.hide_estimated_cost;
        item.hide_estimated_hours = self.hide_estimated_hours;

        if (groupCodes.indexOf(item.inspection_group) < 0) {
          groupCodes.push(item.inspection_group);
        }
      });

      angular.forEach(groupCodes, function (group) {
        var groupItems = items.filter(function (item) {
          return item.inspection_group === group;
        });
        var groupData = groups.filter(function (item) {
          return item.code === group;
        })[0];

        self.groups.push({
          code       : group,
          description: groupData.description,
          id         : groupData.id,
          items      : groupItems,
          ordering   : groupItems[0].group_ordering
        });
      });
    });
  };

  Inspection.prototype.save = function (form) {
    var self       = this;
    var url        = self.id ? '/inspection' : '/inspections';
    var method     = self.id ? 'patch' : 'post';
    var inspection = {};
    var items      = [];

    angular.forEach(self.groups, function (group) {
      items = items.concat(group.items.map(item => {
        /**
          * Angular's http json parser throws an
          * error when trying to stringify the form
          * object on each item. So remove them.
         */
        delete item.form;

        return item;
      }));
    });

    inspection.inspection_items_attributes = items;

    inspection.id                 = self.id;
    inspection.customer_id        = self.customer_id;
    inspection.vehicle_id         = self.vehicle_id;
    inspection.template_id        = self.template_id;
    inspection.inspection_date    = self.inspection_date;
    inspection.inspection_status  = self.inspection_status;
    inspection.description        = self.description;
    inspection.service_adviser_id = self.service_adviser_id;
    inspection.contact_name       = self.contact_name;
    inspection.contact_number     = self.contact_number;
    inspection.contact_email      = self.contact_email;
    inspection.customer_email     = self.customer_email;
    inspection.customer_comments  = self.customer_comments;
    inspection.email_sent         = self.email_sent;
    inspection.customer_viewed    = self.customer_viewed;
    inspection.comment1           = self.comment1;
    inspection.comment2           = self.comment2;

    return workshopAPI[method](url, inspection, 'inspection');

  };

  Inspection.prototype.finalize = function () {
    var self = this;

    return confirm.generic($translate.instant('JS_SPACE.CONFIRM.FINALISE_INSPECTION'))
      .then(function () {
        return workshopAPI.get('/inspection/finalize', self.id);
      });
  };

  Inspection.prototype.void = function() {
    var self = this;

    return workshopAPI.get('/inspection/void_inspection', self.id);
  };

  Inspection.prototype.convertToInvoice = function () {
    var self = this;

    return $q.when().then(function () {
      return self.company_settings.has_workshop ?
        $q.when():
        confirm.subscribe($translate.instant('JS_SPACE.CONFIRM.SUBSCRIBE_TO_WORKSHOP_SOFTWARE'), { routes: SUBSCRIPTIONKEYS.workshop.routes, link: SUBSCRIPTIONKEYS.workshop.link });
    }).then(function () {
      return confirm.generic($translate.instant('JS_SPACE.CONFIRM.CONVERT_INSPECTION'));
    }).then(function () {
      return workshopAPI.get('/inspection/convert_to_invoice', self.id);
    });
  };

  Inspection.prototype.convertToEvent = function () {
    var self = this;

    return $q.when().then(function () {
      return self.company_settings.has_workshop ?
        $q.when():
        confirm.subscribe($translate.instant('JS_SPACE.CONFIRM.SUBSCRIBE_TO_WORKSHOP_SOFTWARE'), { routes: SUBSCRIPTIONKEYS.workshop.routes, link: SUBSCRIPTIONKEYS.workshop.link });
    }).then(function () {
      return confirm.generic($translate.instant('JS_SPACE.CONFIRM.CONVERT_INSPECTION'));
    }).then(function () {
      return workshopAPI.get('/inspection/convert_to_event', self.id);
    });
  };

  Inspection.prototype.returnToInvoice = function () {
    var self = this;

    return $q.when().then(function () {
      return self.company_settings.has_workshop ?
        $q.when():
        confirm.subscribe($translate.instant('JS_SPACE.CONFIRM.SUBSCRIBE_TO_WORKSHOP_SOFTWARE'), { routes: SUBSCRIPTIONKEYS.workshop.routes, link: SUBSCRIPTIONKEYS.workshop.link });
    }).then(function () {
      return confirm.generic($translate.instant('JS_SPACE.CONFIRM.RETURN_INSPECTION_INVOICE'));
    }).then(function () {
      return workshopAPI.get('/inspection/return_to_invoice', self.id);
    });
  };

  Inspection.prototype.returnToEvent = function () {
    var self = this;

    return $q.when().then(function () {
      return self.company_settings.has_workshop ?
        $q.when():
        confirm.subscribe($translate.instant('JS_SPACE.CONFIRM.SUBSCRIBE_TO_WORKSHOP_SOFTWARE'), { routes: SUBSCRIPTIONKEYS.workshop.routes, link: SUBSCRIPTIONKEYS.workshop.link });
    }).then(function () {
      return confirm.generic($translate.instant('JS_SPACE.CONFIRM.RETURN_INSPECTION_EVENT'));
    }).then(function () {
      return workshopAPI.get('/inspection/return_to_event', self.id);
    });
  };

  Inspection.prototype.email = function (vehicle, body) {
    var self = this;

    return messengerApi.email({
      body,
      email              : self.customer_email,
      id                 : self.id,
      requesting_approval: true,
      subject            : `${ $translate.instant('INSPECTIONS_SPACE.IMPORTANT_INFORMATION_EMAIL_SUBJECT') } ${ vehicle.make } ${ vehicle.model }'`
    }, {
      bodyParamName: false,
      factory      : InspectionEmailComponent,
      url          : '/inspection/send_email'
    });
  };

  Inspection.prototype.print = function() {
    var self = this;

    return $q.when($window.open(`${API.url}/reports/jasper_inspection/${self.id}.pdf`, '_blank'));
  };

  Inspection.prototype.sms = function (customer, body) {
    var self = this;

    return messengerApi.sms({
      attachment_type    : 'inspection',
      customer_id        : customer.id,
      inspection_id      : self.id,
      message            : body,
      name               : customer.display_name,
      requesting_approval: true,
      send_to            : customer.mobile
    }, {
      factory: InspectionSmsComponent,
    });
  };

  Inspection.prototype.approveItems = function () {
    var self = this;

    return $uibModal.open({
      controller : 'ApproveInspectionCtrl',
      templateUrl: ApproveInspectionHtml,
      windowClass: 'lg-modal',
      resolve    : {
        inspection_id: () => self.id,
        items        : ['workshopAPI', workshopAPI => workshopAPI.get('/inspection/approval_items', self.id)],
        settings     : ['workshopAPI', workshopAPI => workshopAPI.get('/inspection_setting')]
      }
    }).result;
  };

  return Inspection;
};